import { Filter } from '@/global';
import { createSlice } from '@reduxjs/toolkit';

import { startOfMonth, subMonths } from 'date-fns';

type FilterState = {
  value: Filter;
};

const today = new Date();

const initialState: FilterState = {
  value: {
    branch: 'all',
    shipmentType: 'all',
    shipmentStatus: 'all',
    ptlType: 'all',
    date: {
      from: startOfMonth(
        subMonths(new Date(today.getFullYear(), today.getMonth() - 1, 1), 0)
      ).toJSON(),
      to: today.toJSON(),
    },
    dateFilterType: 'dispatch',
    destination: null,
    searchTerm: '',
  },
};

export const filter = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    applyFilter: (state, action) => {
      state.value = action.payload;
    },

    updateFromBranch: (state, action) => {
      state.value.branch = action.payload;
    },

    updateDate: (state, action) => {
      state.value.date = {
        from: action.payload.from,
        to: action.payload.to,
      };
    },

    updateDestination: (state, action) => {
      state.value.destination = action.payload;
    },

    updatePtlType: (state, action) => {
      state.value.ptlType = action.payload;
    },

    updateShipmentStatus: (state, action) => {
      state.value.shipmentStatus = action.payload;
    },

    updateShipmentType: (state, action) => {
      state.value.shipmentType = action.payload;
    },

    updateSearchTerm: (state, action) => {
      state.value.searchTerm = action.payload;
    },

    resetFilter: (state) => {
      state.value = initialState.value;
    },
  },
});

export const {
  updateFromBranch,
  updateDate,
  updateDestination,
  updatePtlType,
  updateShipmentStatus,
  updateShipmentType,
  updateSearchTerm,
  resetFilter,
  applyFilter,
} = filter.actions;

export default filter.reducer;
